import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { Pricing as PricingSection } from "../components/Pricing";
import { Faq } from "../components/Faq";
import { FooterCta } from "../components/FooterCta";
import { Seo } from "../components/Seo";
import { useLang, useLp } from "../lib/i18n";
import { useCloudPricingCopy } from "../lib/cloud-pricing";
import { pricingPageCopy } from "../lib/translations/pages/pricing";

export function Pricing() {
  const lang = useLang();
  const lp = useLp();
  const t = useCloudPricingCopy()?.page ?? pricingPageCopy[lang];

  return (
    <div className="min-h-screen flex flex-col">
      <Seo
        title={t.seo.title}
        description={t.seo.description}
        path="/pricing"
        schema="product"
      />
      <Header />

      <main className="flex-1">
        <section className="border-b border-margin dark:border-paper/10">
          <div className="mx-auto max-w-3xl px-6 pt-20 pb-16 sm:pt-28 sm:pb-20">
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink/55 dark:text-paper/55">
              {t.eyebrow}
            </p>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl font-semibold tracking-tight text-ink dark:text-paper">
              {t.heading}
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-ink/75 dark:text-paper/75">
              {t.intro}
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-3">
              <a
                href="#pricing"
                className="inline-flex items-center rounded-full bg-ink px-6 py-3 text-sm font-medium text-paper hover:bg-ink/90 transition-colors dark:bg-paper dark:text-ink dark:hover:bg-paper/90"
              >
                {t.primaryCta}
              </a>
              <Link
                to={lp + "/downloads"}
                className="inline-flex items-center rounded-full border border-ink/15 dark:border-paper/15 px-6 py-3 text-sm font-medium text-ink dark:text-paper hover:bg-ink/5 dark:hover:bg-paper/5 transition-colors"
              >
                {t.secondaryCta}
              </Link>
            </div>
          </div>
        </section>

        <Reveal><PricingSection /></Reveal>
        <Reveal><Faq /></Reveal>
        <Reveal><FooterCta /></Reveal>
      </main>

      <Footer />
    </div>
  );
}
